import { TypeGenerator } from '../utils/type';
import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';


export function COUNT(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;
  const firstArgType = args[0];

  if (firstArgType.isArray) {
    if (args.length > 1) {
      throw new InferenceError('function-argument-error', `${functionName} 函数的参数仅支持多个单值或单个数组`, token.position);
    }
    return TypeGenerator.Integer();
  }

  if (args.length === 1) {
    return TypeGenerator.Integer();
  }

  if (args.slice(1).some(item => !!item.isArray)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的参数仅支持多个单值或单个数组`, token.position);
  }

  return TypeGenerator.Integer();
}
